import { Terminal } from './terminal';
import { Vehicle } from './vehicle';
import { Picture } from './picture';
import { Time } from '@angular/common/src/i18n/locale_data_api';
import { Roi } from './roi';
import { Device } from './device';

export class Tchek {
    id: string;
    date: Date;
    time: Time;
    path: string;
    way: string;
    idVehicule: number;
    number: number;
    vehicle: Vehicle;
    pictures: Picture[];
    isNew: string;
    rois: Array<Roi>;
    urlImage: string;
    isSigned: boolean;
    isUploaded: boolean;
    isDeletedFromLocal: boolean;
    unavailable: string; // Represents why the tchek is unavailable (uploading, archived, corrupted, cloud)
    providerSig: string;
    webObjectId: string;
    customerSig: string;
    dateSignature: Date;
    devicePtr: Device;
    uploadHDPictures: boolean;
    toDownload: number;
    toUpload: number;
    detectionFinished: boolean;
    objectDetected: DetectionCounts;
    probabilityVehicle: number;

    constructor(id: string = undefined) {
        this.id = id;
    }
    /*constructor(id: number, date: Date, time: Time, path: string, idVehicule: number, vehicle: Vehicle, pictures: Picture[], isNew: string, rois: Array<Roi>) {
          this.id = id;
          this.date = date;
          this.time = time;
          this.path = path;
          this.idVehicule = idVehicule;
          this.vehicle = vehicle;
          this.pictures = pictures;
          this.isNew = isNew;
          this.rois = rois;

      }*/

    setAsUnavailable(reason: string) { // reason : [uploading, archived, cloud, corrupted]
        switch (reason) {
            case 'uploading':
                this.urlImage = 'assets/icon/uploading2x.png';
                this.unavailable = 'uploading';
                break;
            case 'archived':
                this.urlImage = 'assets/icon/archived@2x.png';
                this.unavailable = 'archived';
                break;
            case 'cloud':
                this.urlImage = 'assets/icon/cloud@2x.png';
                this.unavailable = 'cloud';
                break;
            case 'corrupted':
            default:
                this.urlImage = 'assets/icon/corrupted@2x.png';
                this.unavailable = 'corrupted';
                break;
        }
    }
}

export interface DetectionCounts {
    poc: number;
    scratch: number;
}



// WEBPACK FOOTER //
// ./src/app/model/tchek.ts